import CancelablePromise from "cancelable-promise";
import type { SuperLoaderPlugin } from "../Services/SuperLoaderPlugin";
import { PlayerTexturesKey } from "./PlayerTextures";
import type { WokaTextureDescriptionInterface, PlayerTextures } from "./PlayerTextures";
import Texture = Phaser.Textures.Texture;
import LoaderPlugin = Phaser.Loader.LoaderPlugin;
import { CHARACTER_HEIGHT } from "./Character";

export interface FrameConfig {
    frameWidth: number;
    frameHeight: number;
}

export const loadAllLayers = (
    load: LoaderPlugin,
    playerTextures: PlayerTextures
): WokaTextureDescriptionInterface[][] => {
    const returnArray: WokaTextureDescriptionInterface[][] = [];
    playerTextures.getLayers().forEach((layer) => {
        const layerArray: WokaTextureDescriptionInterface[] = [];
        Object.values(layer).forEach((textureDescriptor) => {
            layerArray.push(textureDescriptor);
            if (!textureDescriptor.url) {
                console.warn("Player resource has no URL", textureDescriptor);
                return;
            }
            load.spritesheet(textureDescriptor.id, textureDescriptor.url, { frameWidth: 32, frameHeight: CHARACTER_HEIGHT });
        });
        returnArray.push(layerArray);
    });
    return returnArray;
};
export const loadAllDefaultModels = (
    load: LoaderPlugin,
    playerTextures: PlayerTextures
): WokaTextureDescriptionInterface[] => {
    const returnArray = Object.values(playerTextures.getTexturesResources(PlayerTexturesKey.Woka));
    returnArray.forEach((playerResource: WokaTextureDescriptionInterface) => {
        if (!playerResource.url) {
            console.warn("Player resource has no URL", playerResource);
            return;
        }
        const { frameHeight, frameWidth } = extractTextureDims(playerResource);
        load.spritesheet(playerResource.id, playerResource.url, { frameWidth, frameHeight });
    });
    return returnArray;
};

export const loadWokaTexture = (
    superLoaderPlugin: SuperLoaderPlugin,
    texture: WokaTextureDescriptionInterface
): CancelablePromise<Texture> => {
    return superLoaderPlugin.spritesheet(texture.id, texture.url, {
        frameWidth: 32,
        frameHeight: CHARACTER_HEIGHT,
    });
};

export const lazyLoadPlayerCharacterTextures = (
    superLoaderPlugin: SuperLoaderPlugin,
    textures: WokaTextureDescriptionInterface[]
): CancelablePromise<string[]> => {
    const promisesList: CancelablePromise<Texture>[] = [];
    for (const texture of textures) {
        const { frameHeight, frameWidth } = extractTextureDims(texture);

        promisesList.push(
            superLoaderPlugin.spritesheet(texture.id, texture.url, {
                frameWidth,
                frameHeight,
            })
        );
    }
    const returnPromise: CancelablePromise<Texture[]> = CancelablePromise.all(promisesList);

    return returnPromise.then(() =>
        textures.map((key) => {
            return key.id;
        })
    );
};

const extractTextureDims = (texture: WokaTextureDescriptionInterface) => {
    const defaultFrameDim = 32;
    let frameWidth = defaultFrameDim;
    let frameHeight = CHARACTER_HEIGHT;

    // let filename = texture.url.split('/').pop()?.split('.')[0];
    // filename?.split('_').forEach(value => {
    //     if (value.includes('dim')) {
    //         const dims = value.split('dim').pop()?.split('x');
    //         if (dims && dims[0] && dims[1]) {
    //             frameWidth = Math.ceil(Number(dims[0]) / 3);
    //             frameHeight = Math.ceil(Number(dims[1]) / 4);
    //             // console.log(texture.id, frameHeight, frameWidth);
    //         }
    //     }
    // });

    return {
        frameWidth,
        frameHeight,
    }
}